import { Button } from '@nike/frame-component-library';
import PropTypes from 'prop-types';
import React from 'react';

// to be used for all clear, rerouting, and unimportant buttons

const ButtonWhite = ({
  className, isDisabled, label, onAway, onClick, onHover, style, beforeSlot
}) => (
  <Button
    className={`ncss-btn-secondary-dark ${className}`}
    isDisabled={isDisabled}
    style={{ flexDirection: 'row', verticalAlign: 'middle', ...style }}
    onClick={onClick}
    onMouseLeave={onAway}
    onMouseOver={onHover}
  >
    <span style={{ display: 'flex' }}>
      {beforeSlot || <></>}{label}
    </span>
  </Button>
);

ButtonWhite.defaultProps = {
  beforeSlot: null,
  className: 'mt10-sm border',
  isDisabled: false,
  onAway: () => {},
  onHover: () => {},
  style: {},
};

ButtonWhite.propTypes = {
  beforeSlot: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onAway: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  onHover: PropTypes.func,
  style: PropTypes.shape(),
};

export default ButtonWhite;
